import { BreederAdminUser, ManagedBreeder } from 'dogpark/types';

export interface BreederAdminsState {
  loading: boolean;
  breederAdmins: BreederAdminUser[];
  fetchBreederAdmins: boolean;
}

export const breederAdminsInitState: BreederAdminsState = {
  loading: false,
  breederAdmins: [],
  fetchBreederAdmins: true,
};

export type BreederAdminsAction =
  | { type: 'LOAD_BREEDER_ADMIN' }
  | { type: 'SET_BREEDER_ADMIN'; payload: { breederAdmins: BreederAdminUser[] } }
  | { type: 'SET_FETCH_BREEDER_ADMIN' }
  | {
      type: 'SET_BREEDER_ADMIN_MANAGED_BREEDERS';
      payload: { userId: number; managedBreeders: ManagedBreeder[] };
    };

export const breederAdminsReducer = (
  state: BreederAdminsState,
  action: BreederAdminsAction,
): BreederAdminsState => {
  switch (action.type) {
    case 'LOAD_BREEDER_ADMIN': {
      return { ...state, loading: true };
    }
    case 'SET_BREEDER_ADMIN': {
      const { breederAdmins } = action.payload;
      return { ...state, breederAdmins, loading: false, fetchBreederAdmins: false };
    }
    case 'SET_FETCH_BREEDER_ADMIN': {
      return { ...state, fetchBreederAdmins: true, breederAdmins: [] };
    }
    case 'SET_BREEDER_ADMIN_MANAGED_BREEDERS': {
      const { userId, managedBreeders } = action.payload;
      const { breederAdmins } = state;

      const breederAdminsUpdated = breederAdmins.map((breederAdmin) => {
        return breederAdmin.id === userId
          ? { ...breederAdmin, managedBreeders }
          : breederAdmin;
      });

      return { ...state, breederAdmins: breederAdminsUpdated };
    }
  }
};
